<script>
import imageTransform from 'foundation/js/imageTransformation/imageTransform'
import { recipe_4_5 } from 'foundation/js/imageTransformation/imagePresets'

export default {
  name: 'RecipeCard',
  props: ['result', 'displayProperties', 'imageRatio', 'imageType'],
  setup() {
    return { imageTransform, recipe_4_5 }
  }
}
</script>

<template>
  <a class="kb-general-search__recipe-result" :href="result.url">
    <div
      class="kb-general-search__result-content-image"
      :class="
        (imageType
          ? `kb-general-search__result-content-image--${imageType}`
          : null,
        imageRatio
          ? `kb-general-search__result-content-image--${imageRatio}`
          : null)
      "
    >
      <img :src="imageTransform(result.imageUrl, recipe_4_5)" alt="" />
    </div>
    <div class="kb-general-search__result-content">
      <h2 class="kb-general-search__result-title" v-html="result.title"></h2>
      <ul class="kb-general-search__details">
        <template v-for="(detail, tagindex) in result.details" :key="tagindex">
          <li>
            <span class="kb-general-search__detail">
              <div class="kb-general-search__detail__icon">
                <div :class="`kb-ui-icon ${detail.icon}`"></div>
              </div>
              <p>{{ detail.name }}</p>
            </span>
          </li>
        </template>
      </ul>
    </div>
  </a>
</template>
